import axios from "axios";
import {
  BlobFolderPage,
  BlobInformation,
  FileExport,
  PartialBlob,
} from "../types";
import config from "../../../config";

const apiUrl = config.api;

const toRequestBlob = (blob: PartialBlob) => ({
  name: blob.name,
  containerName: blob.containerName,
});

export const getAllBlobInformation = async (): Promise<BlobInformation> => {
  const response = await axios.get<BlobInformation>(`${apiUrl}/file-explorer`);
  return response.data;
};

// Gets one section of a folder's files. Leave continuationToken out for the
// first section.
export const getBlobFolderPage = async (
  containerName: string,
  continuationToken?: string | null,
): Promise<BlobFolderPage> => {
  const response = await axios.get<BlobFolderPage>(
    `${apiUrl}/file-explorer/folders/${encodeURIComponent(containerName)}`,
    { params: continuationToken ? { continuationToken } : undefined },
  );
  return response.data;
};

export const getFileBlob = async (blob: PartialBlob): Promise<FileExport> => {
  const response = await axios.post<FileExport>(
    `${apiUrl}/files-explorer/blob`,
    toRequestBlob(blob),
  );
  return response.data;
};

export const deleteBlobs = async (blobs: PartialBlob[]): Promise<void> => {
  await axios.delete(`${apiUrl}/files-explorer`, {
    data: blobs.map(toRequestBlob),
  });
};

export const rehydrateBlobs = async (blobs: PartialBlob[]): Promise<void> => {
  await axios.post(
    `${apiUrl}/files-explorer/rehydrate`,
    blobs.map(toRequestBlob),
  );
};
